import type { Locale } from '@yi/core';

import { LOGGED_IN_HOME_PATHNAME, LOGGED_OUT_HOME_PATHNAME } from '~/src/common/routes';

import { getLocalizedPath } from './getLocalizedPath';

export function getHomePathname(isLoggedIn: boolean, locale: Locale) {
  const homePathname = isLoggedIn ? LOGGED_IN_HOME_PATHNAME : LOGGED_OUT_HOME_PATHNAME;

  const localizedHomePathname = getLocalizedPath(homePathname, locale);

  return localizedHomePathname;
}
